/**
 * Minimal HTML-entity escape for string content inlined into a cellRenderer's
 * HTML output. AG-Grid's `cellRenderer` API accepts raw HTML strings, so any
 * backend value interpolated into one MUST be escaped or it can break out of
 * the surrounding markup. Covers the five OWASP-recommended characters; that's
 * enough for attribute/text contexts (we never inline into URL/script/style).
 *
 * Consolidated from two near-identical helpers that used to live in
 * `calls.component.ts` and `call-details/call-details-dialog.component.ts`.
 */
export function escapeHtml(s: string): string {
  return s
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}
